import { GridRows, GridColumns } from '@visx/grid';
import BaseGrid from "./BaseGrid.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Grid(props) {
  return /*#__PURE__*/_jsx(BaseGrid, {
    GridRowsComponent: GridRows,
    GridColumnsComponent: GridColumns,
    ...props
  });
}